import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-maintenance-plan-details-form',
  templateUrl: './maintenance-plan-details-form.component.html',
  styleUrls: ['./maintenance-plan-details-form.component.scss']
})
export class MaintenancePlanDetailsFormComponent implements OnInit {
  @Input() showErrors = false;

  name: string;
  description: string;
  hasDocuments = false;
  documents = [];

  form: UntypedFormGroup;

  constructor() {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(this.name, [Validators.required]),
      description: new UntypedFormControl(this.description, [Validators.required]),
    });
  }

  ngOnInit() {
  }

  get valid() {
    return this.form.valid && (!this.hasDocuments || this.documents.length > 0);
  }

  reset() {
    this.form.reset();
    this.documents = [];
  }

  selectFiles(event: any) {
    this.documents = event;
  }

  init(plan: any) {
    this.name = plan.name;
    this.description = plan.description;

    this.form.setValue({
      name: this.name,
      description: this.description
    });
  }

  getFormValue() {
    return {
      ...this.form.value,
      hasDocuments: this.hasDocuments,
      documents: this.documents
    };
  }
}
